<template>
	<div>
		<!-- begin breadcrumb -->
		<ol class="breadcrumb float-xl-right">
            <li class="breadcrumb-item"><router-link :to="{ path: '/' }">Home</router-link></li>
			<li class="breadcrumb-item active"><a href="javascript:;">Projects</a></li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Projects <small>List of projects</small></h1>
		<!-- end page-header --> 


        <button class="btn btn-info btn-themex mb-2">New Project</button>

        <vue-good-table 
            :columns="columns" 
            :rows="rows" 
            :lineNumbers="false"
            :search-options="{ enabled: true, placeholder: 'Search term' }" 
            :pagination-options="{ enabled: true,  position: 'bottom' }"
            @on-row-click="onRowClick"
            :selectOptions="{
                enabled: true,
                selectOnCheckboxOnly: true,
                selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
            }"
        >
            <div slot="selected-row-actions" style="margin: -2px 0;">
                <button class="btn btn-xs btn-primary m-r-5">Action 1</button>
                <button class="btn btn-xs btn-primary">Action 2</button>
            </div>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'status'">
                    <span class="label label-lg label-success">{{props.row.status}}</span>
                </span>
                <span v-else-if="props.column.field == 'products'">
                    <span v-for="(product, index) in props.row.products" :key="`product-${index}`" class="label label-lg label-theme m-r-3">{{ product }}</span>
                </span>
                <span v-else>
                    {{props.formattedRow[props.column.field]}}
                </span>
            </template>
        </vue-good-table>
	</div>
</template>

<script>

    export default {
        data() {
            return {
                projects: [],
                columns: [
                {
                    label: 'Project ID',
                    field: 'id',
                    width: '5%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap'
                },
                {
                    label: 'Name',
                    field: 'name',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap'
                }, {
                    label: 'Description',
                    field: 'description',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap'
                }, {
                    label: 'Products',
                    field: 'products',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: false,
                }, {
                    label: 'Status',
                    field: 'status',
                    tdClass: 'text-center text-nowrap',
                    thClass: 'text-center text-nowrap'
                }, {
                    label: 'Created On',
                    field: 'createdAt',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'MMMM dd, yyyy',
                    width: '10%',
                    tdClass: 'text-center text-nowrap',
                    thClass: 'text-center text-nowrap'
                }],
                rows: [
                    //{ id:1, name:'', description: '', products: ['InsulFound', 'QuicFence'], status: 'Unknown', createdAt: '2018-10-31' }
                ]
            }
        },

        created ()
        {
            this.fetchItems();
        },

        methods: {
            fetchItems()
            {
                this.$http.get('/projects').then((response) => {
                    this.projects = response.data
                })
            },
            onRowClick(params) {
                // params.row - row object 
                // params.pageIndex - index of this row on the current page.
                // params.selected - if selection is enabled this argument 
                // indicates selected or not
                // params.event - click event
                this.$router.push({ name: 'Project', params: { id: params.row.id } })
                console.log(params)
            }
        }
    }
</script>